export default __webpack_public_path__ + "static/media/toggleInner.4ccd687d.svg";